import {
  IconBuilding,
  IconFileDescription,
  IconQuestionMark,
  IconScale,
  IconSearch,
  IconShieldCheck,
  IconUser,
  IconUsers,
} from '@tabler/icons-react'

export const BRAND_COLOR = '#195AD6'

export const HERO_CONTENT = {
  badge: '信息查询 · 授权展示 · 数据服务',
  title: '悦享查 · 个人与企业信息查询平台',
  subtitle: '在用户授权前提下，向第三方机构请求信息并进行查询展示',
  note: '平台仅对信息进行查询、整理与展示，不提供任何判断、评估或建议',
  features: ['经用户明确授权后请求信息', '仅展示信息，不做判断', '有限期保存，服务期后自动清除'],
  compliance:
    '悦享查不提供任何形式的金融、借贷、投资、信用或风险评估相关服务，也不参与任何交易或撮合行为。平台仅负责信息的查询与展示。',
}

export const SERVICE_CONTENT = {
  badge: '服务说明 · 平台定位',
  title: '我们提供什么服务？',
  subtitle:
    '悦享查是一个个人与企业信息查询平台。在获得用户明确授权的前提下，平台可向第三方机构请求相关信息，并将查询结果进行整理与展示，帮助用户清晰查看信息内容本身。',
  note: '平台仅承担信息展示职责，信息的理解与使用由查看信息的用户自行决定。',
}

export const SOURCE_CONTENT = {
  badge: '信息来源 · 数据说明',
  title: '信息来源说明',
  sources: [
    {
      icon: IconShieldCheck,
      title: '授权请求',
      description: '经用户明确授权后，向第三方机构请求相关信息',
    },
    {
      icon: IconUser,
      title: '用户提供',
      description: '用户自行提供的信息',
    },
    {
      icon: IconSearch,
      title: '公开渠道',
      description: '依法公开可查的信息渠道',
    },
  ],
  note: '平台不对信息进行加工判断，仅进行结构化展示。',
}

export const QUERY_TYPES_CONTENT = {
  badge: '查询类型 · 服务范围',
  title: '支持的信息查询类型',
  types: [
    { icon: IconUser, title: '个人相关信息记录' },
    { icon: IconBuilding, title: '企业基础信息条目' },
    { icon: IconFileDescription, title: '状态类信息展示' },
    { icon: IconSearch, title: '已有信息字段核对' },
  ],
  note: '查询结果以客观信息呈现，不包含结论性内容',
}

export const BOUNDARY_CONTENT = {
  badge: '平台边界 · 服务范围',
  title: '平台边界说明',
  boundaries: [
    { icon: IconScale, text: '不对信息进行好坏、风险或可行性判断' },
    { icon: IconQuestionMark, text: '不提供任何建议或决策支持' },
    { icon: IconUsers, text: '不参与任何交易、撮合或协商行为' },
    { icon: IconBuilding, text: '不涉及金融、借贷、投资等业务' },
  ],
}

export const STORAGE_CONTENT = {
  badge: '信息保存 · 查看说明',
  title: '信息保存与查看说明',
  description: '为完成用户已付费的信息展示服务，在用户授权前提下，查询结果将被有限期保存，最长不超过 30 天。',
  points: ['用户本人', '或用户明确授权的对象查看'],
  note: '平台不进行长期留存，不用于分析、画像或其他用途，服务期结束后自动清除。',
}

export const USAGE_CONTENT = {
  badge: '使用说明 · 责任声明',
  title: '使用说明',
  description: '平台仅负责信息的查询与展示。用户应自行理解并使用查询结果。',
  note: '基于查询结果所产生的任何判断、决策或行为，均由用户自行承担责任。',
}

export const FAQ_CONTENT = {
  badge: '常见问题 · Q&A',
  title: '常见问题',
  questions: [
    {
      q: '悦享查是做什么的？',
      a: '悦享查是一个个人与企业信息查询平台。在获得用户明确授权的前提下，平台向第三方机构请求相关信息，并将查询结果进行整理与展示，帮助用户查看信息内容本身。',
    },
    {
      q: '悦享查会对信息做分析或判断吗？',
      a: '不会。平台仅负责信息的查询、整理与展示，不对信息进行任何判断、评估或结论性分析。',
    },
    {
      q: '这些信息是从哪里来的？',
      a: '在获得用户明确授权的前提下，平台向第三方机构请求相关信息；同时，部分信息来源于用户自行提供或依法公开可查的渠道。平台仅对获取的信息进行展示与整理。',
    },
    {
      q: '使用悦享查是否涉及金融、借贷或投资？',
      a: '不涉及。悦享查不提供任何金融、借贷、投资、信用或风险评估相关服务，也不参与任何交易或撮合行为。',
    },
    {
      q: '平台会不会给出建议，告诉我该怎么做？',
      a: '不会。平台仅展示信息内容，信息的理解与使用由查看信息的用户自行决定。',
    },
    {
      q: '查询结果会被平台保存吗？',
      a: '为完成用户已付费的信息展示服务，在用户授权前提下，查询结果将被有限期保存，最长不超过 30 天，仅供用户本人或其授权对象查看。服务期结束后，相关内容将自动清除。',
    },
    {
      q: '平台会不会分析或利用这些数据？',
      a: '不会。平台不对查询结果或用户行为进行分析、画像、推荐或任何其他用途的利用。',
    },
    {
      q: '除了我本人，还有谁可以查看查询结果？',
      a: '仅限用户本人，或用户明确授权的对象查看。平台工作人员无法随意调取或查看查询结果。',
    },
    {
      q: '平台是否会向第三方提供或出售数据？',
      a: '不会。平台不会向任何第三方提供、出售或共享用户的查询结果数据。',
    },
    {
      q: '如果我根据查询信息产生纠纷，平台是否负责？',
      a: '平台仅提供信息查询与展示服务，不对信息的使用结果或由此产生的任何行为承担责任。',
    },
  ],
}

export const CTA_CONTENT = {
  badge: '平台说明',
  title: '悦享查 · 个人与企业信息查询平台',
  subtitle: '请确认您对所查询信息拥有合法授权，并同意平台使用说明与相关条款',
}

export const FOOTER_CONTENT = {
  companyDescription: '悦享查 · 个人与企业信息查询平台，信息查询与展示工具',
  contact: {
    serviceEmail: 'service@yuexiangcha.com',
    bdEmail: 'bd@yuexiangcha.com',
    phone: '400-XXX-XXXX',
    address: '四川省成都市 ××区 ××路 ××号',
  },
  links: {
    products: [
      { label: '个人信息查询', href: '#' },
      { label: '企业信息查询', href: '#' },
      { label: '信息展示服务', href: '#' },
    ],
    solutions: [
      { label: '使用说明', href: '#usage' },
      { label: '合规说明', href: '#boundary' },
      { label: '隐私政策', href: '#' },
    ],
    about: [
      { label: '关于我们', href: '#' },
      { label: '联系方式', href: '#' },
    ],
  },
  legal: {
    copyright: '© 2024 四川陨石科技有限公司 版权所有',
    icp: '蜀ICP备2024089652号-1',
    privacyPolicy: '《隐私政策》',
    termsOfService: '《服务条款》',
    dataCompliance: '《数据安全与合规说明》',
  },
}
